import { render, staticRenderFns } from "./renshiNav.vue?vue&type=template&id=0d83f730&scoped=true"
import script from "./renshiNav.vue?vue&type=script&lang=js"
export * from "./renshiNav.vue?vue&type=script&lang=js"
import style0 from "./renshiNav.vue?vue&type=style&index=0&id=0d83f730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83f730",
  null
  
)

export default component.exports